// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aRCGA{width:100%;min-width:240px;height:160px;flex-shrink:0;border:1px solid transparent;border-radius:10px;box-shadow:0 1px 3px rgba(15,23,42,.06);background-color:#fff;padding:12px;transition:border-color .15s ease,background-color .15s ease,box-shadow .15s ease;text-align:left;box-sizing:border-box;gap:0}.aRCGA.Qyo10{cursor:pointer}@media(hover: hover){.aRCGA.Qyo10:hover{border-color:#d4d4e0}}.aRCGA.Sfra2{border:2px solid #6942f8}.aRCGA.xXFi1{box-shadow:none;opacity:.7}.aRCGA.TCuid{border-color:#d4d4e0}.aRCGA.f9bnm{opacity:.7;transition:opacity .2s ease}.VSdVE{display:flex;align-items:center;justify-content:space-between;min-height:20px}.us_bw{display:flex;flex-direction:row;align-items:center;gap:6px;min-width:0;color:#696992}.us_bw span,.us_bw svg{color:#696992}.tHCNd{color:#696992}.tHCNd.CLW4H{color:#a9a9c1}.x8ewC{display:flex;flex-direction:column;min-width:0}.IPopK{flex:1;display:flex;align-items:center;justify-content:center;min-height:56px}.GM1vU{position:relative;width:100%;min-width:240px}.OF4OA{appearance:none;cursor:pointer;position:absolute;top:-8px;right:-8px;width:22px;height:22px;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:#fff;border:1px solid #d4d4e0;color:#696992;box-shadow:0 1px 3px rgba(15,23,42,.1);z-index:1;flex-shrink:0;transition:background-color .15s ease,color .15s ease,border-color .15s ease}.OF4OA:hover{background:#fcfcfd;color:#282863;border-color:#bfbfd0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"mobileMaxWidth": `560px`,
	"tabletMinWidth": `561px`,
	"tabletMaxWidth": `1024px`,
	"desktopMinWidth": `1025px`,
	"smallScreenMaxWidth": `1400px`,
	"largeScreenMinWidth": `1401px`,
	"card": `aRCGA`,
	"clickable": `Qyo10`,
	"active": `Sfra2`,
	"disabled": `xXFi1`,
	"editMode": `TCuid`,
	"refetching": `f9bnm`,
	"header": `VSdVE`,
	"titleRow": `us_bw`,
	"title": `tHCNd`,
	"titleDisabled": `CLW4H`,
	"body": `x8ewC`,
	"loader": `IPopK`,
	"cardWrapper": `GM1vU`,
	"removeBadge": `OF4OA`
};
export default ___CSS_LOADER_EXPORT___;
